/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { Maybe } from '@irian-ro/util-functions';
import { PackageStatusType } from './package-status-type';

export class PackageVoModel extends JSONable {
  uuid: Maybe<string> | undefined = undefined;
  id: Maybe<string> | undefined = undefined;

  shipmentUuid: Maybe<string> | undefined = undefined;

  height: Maybe<number> | undefined = undefined;

  width: Maybe<number> | undefined = undefined;

  length: Maybe<number> | undefined = undefined;

  weight: Maybe<number> | undefined = undefined;

  volume: Maybe<number> | undefined = undefined;

  pickup: Maybe<string> | undefined = undefined;

  delivery: Maybe<string> | undefined = undefined;

  count: Maybe<number> | undefined = undefined;

  type: Maybe<string> | undefined = undefined;

  tags: string[] = [];

  standardPackageDimensionUuid: Maybe<string> = null;

  standardPackageDimensionName: Maybe<string> = null;

  packageStatusType: Maybe<PackageStatusType> = null;

}
